const styles = theme => ({
  container: {
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    fontSize: '0.875rem',
    color: '#484456',
    fontWeight: 400,
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
  },
  headerText: {
    color: '#130F26',
    fontSize: '1.125rem',
    fontWeight: '600',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.85rem',
    },
  },
  divider: {
    width: '100%',
  },
  marginBottom: {
    marginBottom: '24px',
    border: `1px solid ${theme.palette.secondary.disableLightGray}`,
    overflow: 'hidden',
  },
  titleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      fontSize: '20px',
      // '& $dangerText': {
      //     color: '#D2374F',
      // },
    },
  },
  title: {
    fontWeight: '600',
    marginBottom: '5px',
  },

  innerCard: {
    '@media (max-width: 480px)': {
      flexDirection: 'column',
    },
  },
});

export default styles;
